angular.module('am4').controller('equipmentErrorCodesCtrl', function($scope, $stateParams, $translate, config, machineData, errorCodeService, errorService) {
    var that = this;

    that.nextErrorCodesBatch = function() {
        if ($scope.machineCtrl.errorCodes.length) {
            var nextBatchStartDate = $scope.machineCtrl.errorCodes[$scope.machineCtrl.errorCodes.length - 1].recorded_at;
            $scope.machineCtrl.errorCodes = [];
            $scope.machineCtrl.errorCodesLoaded = false;
            errorCodeService.getEquipmentErrorCodes($stateParams.id, nextBatchStartDate)
            .then(function(res) {
                $scope.machineCtrl.errorCodes = res;
            })
            .catch(function(e) {
                errorService.addError('GET_ALERTS_ERROR', e);
            }).finally(function() {
                $scope.machineCtrl.errorCodesLoaded = true;
            });
        }
    };

    that.refreshErrorCodes = function() {
        $scope.machineCtrl.errorCodes = [];
        $scope.machineCtrl.errorCodesLoaded = false;
        errorCodeService.getEquipmentErrorCodes($stateParams.id)
        .then(function(res) {
            $scope.machineCtrl.errorCodes = res;
        })
        .catch(function(e) {
            errorService.addError('GET_ALERTS_ERROR', e);
        }).finally(function() {
            $scope.machineCtrl.errorCodesLoaded = true;
        });
    };

    that.nextErrorCodesBatchText = $translate.instant('NEXT_N_EVENTS', { n: config.errorCodeServiceRange });

});



// WEBPACK FOOTER //
// ./src/app/controllers/equipment/equipmentErrorCodesCtrl.js